import React from "react"
import PropTypes from "prop-types"
import { Link, NavLink } from "react-router-dom"
import { Row, Col, BreadcrumbItem } from "reactstrap"

const Breadcrumb = props => {
  return (
    <Row>
      <Col xs="12">
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <div className="mb-0 font-size-18">{props.breadcrumbItemTitle}</div>
          <div className="page-title-right">
            <ol className="breadcrumb m-0">
              <BreadcrumbItem>
                <Link to="#">{props.title}</Link>
              </BreadcrumbItem>
              <BreadcrumbItem active>
                <NavLink to={props.breadcrumbItemLink}>
                  {props.breadcrumbItemTitle}
                </NavLink>
              </BreadcrumbItem>
            </ol>
          </div>
        </div>
      </Col>
    </Row>
  )
}

Breadcrumb.propTypes = {
  breadcrumbItemTitle: PropTypes.string,
  title: PropTypes.string,
  breadcrumbItemLink: PropTypes.string,
}

export default Breadcrumb
